<!-- The progressbar that is shown above questions -->
<template>
    <div progressbarfooter aria-live="assertive">
        <div data-bar>
            <span
                data-value-label
            >
                <span data-only-screenreader>{{this.$store.getters.textResource(`rs_progress`)}}</span>
                <p v-if="layout.ProgressBar.ShowPercentageBottom === true">{{ progressPercentage }}%</p>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: `progress-bar-footer`,
    computed: {
        state: function () {
            return this.$store.state;
        },
        progressPercentage: function () {
            let page = this.state.page;
            if (page === undefined) return 0;

            let progress = parseInt(page.progress);

            if (progress < 0) return 0;
            else if (progress > 100 || isNaN(progress)) return 100;
            return progress;
        },
        layout: function () {
            return this.state.layout;
        },
    },
};
</script>

<style scoped>
[progressbarfooter] {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 80px;
    width: 100%;
    padding: 0;

    [data-bar] {
        height: 26px;
        width: 100%;
        display: block;
        position: relative;
    }

    [data-value-label] {
        background: var(--progressbar-color);
        position: absolute;
        left: 0;
        top: -3px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        padding: 5px 10px;
        text-align: center;
        min-width: 80px;
        font-size: 18px;
        font-family: var(--page-font-family-public-name);
        color: var(--progresspercentage-color);
        min-height: 33px;

        p {
            margin: 0;
        }
    }
}
</style>